import { type MenuItemType } from 'owa-filterable-menu/lib/components/MenuItemType';
import { doesUserHaveSharedFolderPermissionFor } from 'owa-mail-filterable-menu-behavior';
import type { HoverActionKey } from 'owa-outlook-service-option-store';

export default function doesFolderOrViewSupportHoverAction(
    action: HoverActionKey,
    canDelete: boolean,
    canArchive: boolean,
    supportsMove: boolean,
    supportsFlagging: boolean,
    supportsPinning: boolean,
    canPin: boolean
): boolean {
    switch (action) {
        case 'Delete':
            // getMailListItemDataProps derives canDelete from shouldAllowDelete
            return canDelete;
        case 'Archive':
            return canArchive;
        case 'Move':
            return supportsMove && doesUserHaveSharedFolderPermissionFor(29);
        case 'FlagUnflag':
            return supportsFlagging && doesUserHaveSharedFolderPermissionFor(18);
        case 'PinUnpin':
            return supportsPinning && canPin && doesUserHaveSharedFolderPermissionFor(39);
        default:
            return true;
    }
}
